module.exports = __webpack_public_path__ + "static/media/logo.49bd0bd7.png";